import { ContentAssistanceValue } from '../api/contentAssistanceApi';

function escapeMarkup(result: string) {
  const tempDiv = document.createElement('div');
  tempDiv.innerText = result;
  return tempDiv.innerHTML;
}

function trimNewLines(result: string) {
  return result.replace(/^\s+|\s+$/g, '');
}

function brToNewLine(result: string) {
  return result.replace(/<br\/?>/g, '\n');
}

function sanitizeString(result: string) {
  const trimmedResult = trimNewLines(result);
  const escapedResult = escapeMarkup(trimmedResult);
  // returning innerHtml has the effect of turning newlines into brs we only support plain text results at the moment
  const plainTextResult = brToNewLine(escapedResult);
  return plainTextResult;
}

function sanitizeArray(result: ContentAssistanceValue[]) {
  return result.map(sanitize);
}

function sanitizeObject(result: {
  [property: string]: ContentAssistanceValue;
}) {
  return Object.fromEntries(
    Object.entries(result).map(([key, value]) => [key, sanitize(value)])
  );
}

export function sanitize<T extends ContentAssistanceValue>(result: T): T {
  if (typeof result === 'string') {
    return sanitizeString(result) as T;
  }

  if (Array.isArray(result)) {
    return sanitizeArray(result) as T;
  }

  if (result && typeof result === 'object') {
    return sanitizeObject(result) as T;
  }

  return result;
}
